import type { Connection, ConsoleStudent, ConsoleTab } from "../types";

/** 타이머 고르기(초) — null = 끄기 · 서버 범위 60..3600 */
export const TIMER_CHOICES: readonly (number | null)[] = [null, 300, 600, 900, 1200, 1800];

/** m:ss */
export const fmtLeft = (s: number) =>
  `${Math.floor(s / 60)}:${String(Math.max(0, s) % 60).padStart(2, "0")}`;

export type SortKey = "name" | "conn";
/** 연결 순서 — 손이 필요한 학생(끊김 · 분리)이 먼저 */
const CONN_ORDER: Record<Connection, number> = { dropped: 0, isolated: 1, online: 2, offline: 3 };

/** 이름/연결 정렬(점수·순위 정렬 없음) */
export function sortStudents(xs: readonly ConsoleStudent[], by: SortKey): ConsoleStudent[] {
  const name = (a: ConsoleStudent, b: ConsoleStudent) =>
    a.nickname.localeCompare(b.nickname, "ko") || a.pid.localeCompare(b.pid);
  return [...xs].sort((a, b) =>
    by === "conn" ? CONN_ORDER[a.connection] - CONN_ORDER[b.connection] || name(a, b) : name(a, b),
  );
}

/**
 * 수업 순서 단계(화면 설계 설명서 1.3 · 2.2) — 1 준비(모드 · 편성 · 배치 · 구간) · 2 진행 · 3 마무리.
 * 메모 · 성취 · 영상 · 교류 룸 초대는 ⚙ 설정 아래(단계 없음 = null).
 */
export type ConsoleStep = 1 | 2 | 3;
export function stepOf(tab: ConsoleTab): ConsoleStep | null {
  return tab === "teams" || tab === "sandbox" || tab === "relay"
    ? 1
    : tab === "room"
      ? 2
      : tab === "script"
        ? 3
        : null;
}

/**
 * 살펴볼 학생(설명서 2.4 ⑥) — 끊김 · 분리 · 막힌 포트가 있는 학생. 순서는 손이 급한 쪽(끊김 → 분리 → 막힘) 다음 이름 —
 * 점수 · 순위가 아니라 지금 상태로만 고른다.
 */
export function needsLook(xs: readonly ConsoleStudent[]): ConsoleStudent[] {
  const rank = (s: ConsoleStudent) =>
    s.connection === "dropped" ? 0 : s.connection === "isolated" ? 1 : 2;
  return sortStudents(
    xs.filter(
      (s) =>
        s.connection === "dropped" ||
        s.connection === "isolated" ||
        (s.connection !== "offline" && s.stalled.length > 0),
    ),
    "name",
  ).sort((a, b) => rank(a) - rank(b));
}
